import { render, staticRenderFns } from "./UploadProductImageDialog.vue?vue&type=template&id=f3309a4c&scoped=true"
import script from "@/views/Products/UploadProductImageDialog/UploadProductImageDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Products/UploadProductImageDialog/UploadProductImageDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Products/UploadProductImageDialog/UploadProductImageDialog.scss?vue&type=style&index=0&id=f3309a4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3309a4c",
  null
  
)

export default component.exports